var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTimeFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.67 2H16.34C19.73 2 22 4.379 22 7.919V16.089C22 19.62 19.73 22 16.34 22H7.67C4.28 22 2 19.62 2 16.089V7.919C2 4.379 4.28 2 7.67 2ZM15.58 15.81C15.83 15.81 16.08 15.68 16.22 15.44C16.44 15.089 16.32 14.629 15.96 14.41L12.4 12.29V7.669C12.4 7.26 12.07 6.919 11.65 6.919C11.24 6.919 10.9 7.26 10.9 7.669V12.72C10.9 12.98 11.04 13.23 11.27 13.36L15.19 15.7C15.31 15.78 15.45 15.81 15.58 15.81Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeFill);
export default __webpack_public_path__ + "static/media/Time-fill.58d0ec26b596a522800f2a0516fea69e.svg";
export { ForwardRef as ReactComponent };